import { Checkbox } from '@london-life/ui/components/checkbox';

export type CheckOption = { value: string; label: string; hint?: string };
type Props = { options: CheckOption[]; selected: string[]; onChange: (next: string[]) => void; disabled?: boolean };

// a list of checkboxes for picking several things (roles for an admin, permissions for a role)
export function CheckList({ options, selected, onChange, disabled }: Props) {
  const toggle = (value: string, on: boolean) =>
    onChange(on ? [...selected, value] : selected.filter((item) => item !== value));
  return (
    <div className="admin-checklist">
      {options.map((option) => (
        <label key={option.value} className="admin-checklist-item">
          <Checkbox
            checked={selected.includes(option.value)}
            onCheckedChange={(state) => toggle(option.value, state === true)}
            disabled={disabled}
          />
          <span>
            <span className="admin-checklist-label">{option.label}</span>
            {option.hint && <span className="admin-checklist-hint">{option.hint}</span>}
          </span>
        </label>
      ))}
    </div>
  );
}
